import { PublicClientApplication } from "@azure/msal-browser"
import { jwtDecode } from "jwt-decode"

const msalConfig = {
    auth: {
        // clientId: "6feca62d-2292-4c37-b270-01e75d6cf6e6",
        // authority: "https://oncueplus.b2clogin.com/oncueplus.onmicrosoft.com/B2C_1_SignUp_SignIn",
        // redirectUri: "http://localhost:3000",
        // knownAuthorities:["oncueplus.b2clogin.com"]
        clientId: "6feca62d-2292-4c37-b270-01e75d6cf6e6",
        authority: "https://login.microsoftonline.com/f9fb708a-33f1-4a45-845b-505f5d0dbefa",
        redirectUri: "http://localhost:3000",
        //redirectUri: "https://configtool.azurefd.net",
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
}

const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;

export const loginRequest = {
    scopes: ["openid","email","profile"]
};


export const acquireAccessToken = async (msalInstance) => {
    try{
        const accounts = msalInstance.getAllAccounts();
        const tokenRequest = {
            ...loginRequest,
            account: accounts[0],
        };
        const tokenResponse = await msalInstance.acquireTokenSilent(tokenRequest);
        if(!tokenResponse){
            msalInstance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
            return;
        }
        const decodedToken = jwtDecode(tokenResponse?.idToken);
        const currentTime = Math.floor(Date.now()/1000);
        //console.log('decodedToken',decodedToken);
        // console.log('currentTime',currentTime);
        // console.log('decodedToken.exp',decodedToken.exp)
        if(decodedToken.exp - currentTime < 300){
            const refreshRequest = {
                ...loginRequest,
                account: accounts[0],
                forceRefresh: true
            };
            const refreshTokenResponse = await msalInstance.acquireTokenSilent(refreshRequest);
            if(!refreshTokenResponse){
                msalInstance.logoutRedirect({
                    postLogoutRedirectUri: "/",
                });
                return;
            }
            return refreshTokenResponse.idToken;
        }
        return tokenResponse.idToken;
    } catch(error){
        console.log('error',error);
        msalInstance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
        return;
    }
};